import { Button, ButtonProps } from '@mui/material';
import { Loader } from './Loader';

interface IProps extends ButtonProps {
  loading?: boolean,
}

export const ButtonWithLoader = ({ loading, disabled, children, ...props }: IProps) => {
  return (
    <Button disabled={disabled || loading} {...props}>
      {children}
      {
        loading &&
        <Loader loaderColor={props.color} width={30} mt={.5}/>
      }
    </Button>
  );
};